'use client';

import BlogCard from '@/components/Blog/BlogCard';
import { Article } from '@/gql/graphql';
import { PostExtract } from '@/services/post.service';
import clsx from 'clsx';
import { uniq } from 'lodash';
import { FC, useEffect, useState } from 'react';

const ArticlesRenderer: FC<{ articles: (Article | PostExtract)[] }> = ({
    articles
}) => {
    const categories = ['Tout les articles'].concat(
        uniq(articles.flatMap((a) => a.category))
    );
    const [selectedCategory, setSelectedCategory] =
        useState('Tout les articles');
    const [displayedArticles, setDisplayedArticles] = useState(articles);

    useEffect(() => {
        if (selectedCategory === 'Tout les articles') {
            setDisplayedArticles(articles);
        } else {
            setDisplayedArticles(
                articles.filter((a) => a.category === selectedCategory)
            );
        }
    }, [selectedCategory, articles]);

    const Selector = () => {
        return (
            <div
                className={
                    'grid grid-cols-2 flex-wrap justify-start py-2 font-title md:grid-cols-3 lg:grid-cols-5 lg:py-6'
                }
            >
                {categories.map((category) => (
                    <button
                        onClick={() => setSelectedCategory(category)}
                        key={category}
                        className={clsx(
                            category === selectedCategory &&
                                'bg-perano text-white shadow',
                            'rounded-full p-3 text-center text-sm capitalize transition-all sm:text-base sm:hover:bg-perano/50'
                        )}
                    >
                        {category.replaceAll('_', '  ')}
                    </button>
                ))}
            </div>
        );
    };

    return (
        <>
            <p
                className={
                    'flex-wrap justify-around text-sm text-neutral-500 sm:mt-4'
                }
            >
                {' '}
                Filtrer par catégorie
            </p>
            <Selector />
            <p className={'mb-4 text-sm text-neutral-500 '}>
                {' '}
                {displayedArticles.length} articles trouvés
            </p>
            <div
                className={
                    'grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 2lg:grid-cols-3 2lg:gap-8'
                }
            >
                {displayedArticles.map((article) => {
                    return <BlogCard key={article.id} article={article} />;
                })}
            </div>
        </>
    );
};

export default ArticlesRenderer;
